module.exports = __webpack_public_path__ + "img/dangjian100.28f50d91.jpg";